import { z } from '@/i18n/zod';

export const signInSchema = z.object({
  email: z.string().email(),
});

export const signInSchemaWithRecaptcha = signInSchema.extend({
  recaptchaToken: z.string(),
});

export const verifyOtpSchema = z.object({
  otp: z.string().length(6),
});
